import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { getArticle } from '@mkcore/portal/schema';
import { Card, ErrorState, Skeleton } from '@mkcore/ui';
import { call } from '@/lib/api';
import { formatDate } from '@/lib/format';
import { Markdown } from '@/components/markdown';

/** One knowledge article for the client (CO-0497). */
export const Route = createFileRoute('/portal/_client/articles/$id')({
  component: Article,
});

function Article() {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  const q = useQuery({ queryKey: ['portal', 'article', id], queryFn: () => call(getArticle, { id }) });
  if (q.isError) return <ErrorState title={t('portal.articles.notFound')} />;
  if (!q.data) return <Skeleton className="h-64" />;
  const a = q.data;
  return (
    <>
      <Link to="/portal/articles" className="flex w-fit items-center gap-1 py-1 text-sm text-fg-2 hover:underline">
        <ArrowLeft className="size-4" aria-hidden /> {t('portal.modules.articles')}
      </Link>
      <article className="grid gap-3">
        <h1 className="text-2xl font-bold">{a.title}</h1>
        <p className="text-xs text-fg-3">{[a.category, t('portal.articles.updated', { at: formatDate(a.updatedAt) })].filter(Boolean).join(' · ')}</p>
        <Card className="p-4">
          <Markdown text={a.body} />
        </Card>
      </article>
    </>
  );
}
